module.exports = __webpack_public_path__ + "img/paypal.bb30402d.svg";